import { render, staticRenderFns } from "./PurchaseDialog.vue?vue&type=template&id=45e040bc&scoped=true"
import script from "./PurchaseDialog.vue?vue&type=script&lang=js"
export * from "./PurchaseDialog.vue?vue&type=script&lang=js"
import style0 from "./PurchaseDialog.vue?vue&type=style&index=0&id=45e040bc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e040bc",
  null
  
)

export default component.exports